// src/components/ProtectedRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = useSelector((state) => state.user.currentUser);
  return isAuthenticated ? element : <Navigate to="/" />;
};

export default ProtectedRoute;
